module.exports = __webpack_public_path__ + "4d6e645f48ebdb67914c03e1b174f27a.png";